<template>
  <div class="message-stats-wrapper">
    <!-- <input
      v-model="searchQuery"
      @input="searchTable"
      placeholder="Rechercher..."
      style="margin-bottom: 10px; padding: 5px"
    /> -->
    <div ref="table" class="table-container"></div>
  </div>
</template>

<script>
import { TabulatorFull as Tabulator } from "tabulator-tables";
import "tabulator-tables/dist/css/tabulator.min.css";
import { DateTime } from "luxon";
window.luxon = { DateTime };

export default {
  data() {
    return {
      table: null,
      tableData: [],
      searchQuery: "",
    };
  },
  mounted() {
    fetch("/api/mc_chat/message-stats-all")
      .then((res) => res.json())
      .then((json) => {
        // Calculer total_count pour chaque ligne
        this.tableData = json.data.map((item) => ({
          ...item,
          total_count:
            (item.received_list_response_count || 0) +
            (item.sent_automatic_count || 0),
        }));
        this.initTable();
      });
  },
  methods: {
    initTable() {
      // Étape 1 : étendre le formatter datetime pour utiliser Luxon
      Tabulator.extendModule("format", "formatters", {
        datetime: function (cell, formatterParams) {
          let value = cell.getValue();
          if (!value) return "";
          return DateTime.fromISO(value).toFormat(
            formatterParams.outputFormat || "yyyy-MM-dd"
          );
        },
      });

      // Étape 2 : créer la table normalement
      this.table = new Tabulator(this.$refs.table, {
        data: this.tableData,
        layout: "fitColumns",
        groupBy: ["client_number", "record_date"],
        groupHeader: [
          function (value) {
            return `Bot ${value}`;
          },
          function (value, count) {
            return `Date : ${value} - ${count} produits distincts`;
          },
        ],
        groupStartOpen: false,

        initialSort: [
          { column: "client_number", dir: "asc" },
          { column: "record_date", dir: "desc" },
        ],
        pagination: "local",
        paginationSize: 70,

        // Ajout du groupCalc pour total_count
        groupCalc: [
          { field: "total_count", type: "sum" },
          { field: "received_product_match_count", type: "sum" },
        ],

        columns: [
          { title: "Produit", field: "product_name", headerFilter: "input" },
          {
            title: "Numéro chatbot",
            field: "client_number",
            headerFilter: "input",
          },
          {
            title: "Date",
            field: "record_date",
            headerFilter: "input",
            headerFilterFunc: "=",
            headerFilterFuncParams: null,
            headerFilterPlaceholder: "YYYY-MM-DD",
            headerFilterLiveFilter: false,
            headerFilterParams: {
              elementAttributes: {
                type: "date",
              },
            },
            sorter: "datetime",
            formatter: "datetime",
            formatterParams: { outputFormat: "yyyy-MM-dd" },
          },
          {
            title: "Messages reçus",
            field: "received_product_match_count",
            sorter: "number",
            bottomCalc: "sum",
          },
          {
            title: "Messages envoyés",
            field: "total_count",
            sorter: "number",
            bottomCalc: "sum",
          },
        ],
      });
    },

    searchTable() {
      this.table.setFilter([
        { field: "product_name", type: "like", value: this.searchQuery },
        { field: "client_number", type: "like", value: this.searchQuery },
      ]);
    },
  },
};
</script>


<style scoped>
.message-stats-wrapper {
  padding: 20px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background-color: #f5f7fa; /* fond doux pour toute la zone */
  border-radius: 10px;
}

.header {
  margin-bottom: 15px;
  text-align: right;
}

.search-input {
  padding: 10px 14px;
  font-size: 14px;
  border: 1px solid #aaa;
  border-radius: 8px;
  width: 280px;
  max-width: 100%;
  transition: all 0.3s ease;
  background-color: #fff;
  color: #333;
}

.search-input:focus {
  outline: none;
  border-color: #4caf50; /* vert agréable au focus */
  box-shadow: 0 0 5px rgba(76, 175, 80, 0.5);
}

.table-container {
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

/* Tabulator styles personnalisés */
.tabulator .tabulator-header {
  background-color: #4caf50; /* en-tête vert */
  color: #fff;
  font-weight: bold;
}

.tabulator .tabulator-row:nth-child(even) {
  background-color: #f9f9f9; /* lignes alternées douces */
}

.tabulator .tabulator-row:hover {
  background-color: #e8f5e9; /* survol vert clair */
}
</style>

